import { render } from "./NotificationTalkBrowseItem.vue?vue&type=template&id=b70b2c5c"
import script from "./NotificationTalkBrowseItem.vue?vue&type=script&lang=js"
export * from "./NotificationTalkBrowseItem.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1003992750/src/frontend-broker/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__